export default __webpack_public_path__ + "static/media/gallery5.2b1c68c5.jpg";